/* iwobbl designer API adapter — App Proxy mode (same-origin).
 * The designer page lives in the theme (/pages/design). API calls go to
 * /apps/design/api/*  ->  Shopify App Proxy forwards to the VPS /proxy/api/*,
 * adding a signature + logged_in_customer_id. Login identity is handled by Shopify;
 * guests use a first-party localStorage token (no third-party cookies). */
(function () {
  var BASE = '/apps/design';                 // App Proxy subpath (prefix 'apps' + subpath 'design')
  var IW = (window.IW = {});
  function localizedUrl(url) {
    return window.IWCurrency ? window.IWCurrency.withContext(url) : url;
  }

  function guestToken() {
    try {
      var t = localStorage.getItem('iw_guest');
      if (!t) { t = 'g_' + Math.random().toString(36).slice(2) + Date.now().toString(36); localStorage.setItem('iw_guest', t); }
      return t;
    } catch (e) { return null; }
  }
  function headers(extra) {
    var h = Object.assign({}, extra || {});
    var g = guestToken(); if (g) h['X-IW-Guest'] = g;   // owner fallback for logged-out users
    return h;
  }

  IW.params = function () {
    var p = new URLSearchParams(location.search);
    var entry = window.__iwDesignerEntry || {};
    var requestedProductType = p.get('productType');
    if (entry.productType) requestedProductType = entry.productType;
    return {
      recipient: p.get('recipient'), intention: p.get('intention'),
      customWish: p.get('customWish'), material: p.get('material'), size: p.get('size'),
      clone: p.get('clone'), mode: p.get('buy') ? 'buy' : (p.get('add') ? 'add' : null),
      start: p.get('start'),
      template: entry.templateId || p.get('template'),
      productType: requestedProductType === 'bracelet' || requestedProductType === 'necklace'
        ? requestedProductType
        : null,
    };
  };

  function mapBead(b) {
    var tex = b.textures || {};
    return {
      id: b.id, name: b.name, nameEn: b.nameEn || b.name_en || b.name,
      category: b.kind, subcategory: b.subcategory,
      sizeMm: b.sizeMm, widthMm: b.widthMm || b.sizeMm, heightMm: b.heightMm || b.sizeMm,
      effectiveAlongMm: b.effectiveAlongMm || b.effective_along_mm || null,
      slotWidthMm: b.slotWidthMm || b.slot_width_mm || null,
      bailWidthMm: b.bailWidthMm || b.bail_width_mm || null,
      price: (b.priceCents || 0) / 100, shape: b.shape || 'round',
      color: b.color || '#ccc', stock: b.stock,
      imageUrl: tex.t96 || tex.t224 || '', textureUrl: tex.t224 || tex.t512 || tex.t96 || '',
      photos: Array.isArray(b.productImages) ? b.productImages : [],
      attach: b.attach || null,
      finish: b.finish || null,
    };
  }

  IW.trays = [];
  IW.sounds = [];
  function designerAssetUrl(datasetKey, fallback) {
    var canvas = typeof document !== 'undefined' ? document.getElementById('trayCanvas') : null;
    return (canvas && canvas.dataset && canvas.dataset[datasetKey]) || fallback;
  }
  function hardwareConstructionType(kit) {
    var raw = String((kit && kit.constructionType) || '').trim().toLowerCase().replace(/-/g, '_');
    if (raw === 'toggle_clasp') return 'toggle_clasp';
    if (raw === 'lobster_wire') return 'lobster_wire';
    var identity = String(((kit && kit.id) || '') + ' ' + ((kit && kit.sku) || '')).toLowerCase();
    return identity.indexOf('toggle') >= 0 ? 'toggle_clasp' : 'lobster_wire';
  }
  function hardwareKitIdentity(kit) {
    return hardwareConstructionType(kit) + ':' + String((kit && kit.finish) || '').trim().toLowerCase();
  }
  IW.hardwareKits = [
    {
      id: 'lobster-wire-gold',
      constructionType: 'lobster_wire',
      finish: 'gold',
      sku: 'IW-HW-LOBSTER-GOLD',
      priceCents: 200,
      stock: 'shopify',
      lengthContributionMm: 30,
      assetUrl: designerAssetUrl('hardwareGoldAssetUrl', 'lobster-wire-gold-double-cap-v4-trimmed.png'),
      terminalAnchors: {
        left: { x: 906 / 2011, y: 704 / 742 },
        right: { x: 1984 / 2011, y: 699 / 742 },
      },
    },
    {
      id: 'lobster-wire-silver',
      constructionType: 'lobster_wire',
      finish: 'silver',
      sku: 'IW-HW-LOBSTER-SILVER',
      priceCents: 200,
      stock: 'shopify',
      lengthContributionMm: 30,
      assetUrl: designerAssetUrl('hardwareSilverAssetUrl', 'lobster-wire-silver-double-cap-v1-trimmed.png'),
      terminalAnchors: {
        left: { x: 921 / 2030, y: 707 / 746 },
        right: { x: 2006 / 2030, y: 702 / 746 },
      },
    },
    {
      id: 'toggle-clasp-gold',
      constructionType: 'toggle_clasp',
      finish: 'gold',
      sku: null,
      priceCents: null,
      stock: 'unconfigured',
      lengthContributionMm: 20,
      displayWidthScale: 0.82,
      assetUrl: designerAssetUrl('hardwareToggleGoldAssetUrl', 'toggle-clasp-gold-trimmed.png'),
      terminalAnchors: {
        left: { x: 0.0264, y: 0.500 },
        right: { x: 0.9725, y: 0.500 },
      },
      attachmentAnchors: {
        toggleRing: {
          x: 0.470,
          y: 0.790,
          centerX: 0.470,
          centerY: 0.497,
          radiusX: 0.302,
          radiusY: 0.293,
          maxCount: 4,
        },
      },
    },
    {
      id: 'toggle-clasp-silver',
      constructionType: 'toggle_clasp',
      finish: 'silver',
      sku: null,
      priceCents: null,
      stock: 'unconfigured',
      lengthContributionMm: 20,
      displayWidthScale: 0.82,
      assetUrl: designerAssetUrl('hardwareToggleSilverAssetUrl', 'toggle-clasp-silver-trimmed.png'),
      terminalAnchors: {
        left: { x: 0.0264, y: 0.500 },
        right: { x: 0.9725, y: 0.500 },
      },
      attachmentAnchors: {
        toggleRing: {
          x: 0.470,
          y: 0.790,
          centerX: 0.470,
          centerY: 0.497,
          radiusX: 0.302,
          radiusY: 0.293,
          maxCount: 4,
        },
      },
    },
  ];

  var CATALOG_REQUEST_TIMEOUT_MS = 12000;
  var CATALOG_RETRY_DELAY_MS = 500;
  var catalogRequestInFlight = null;

  function waitForCatalogRetry() {
    return new Promise(function (resolve) {
      setTimeout(resolve, CATALOG_RETRY_DELAY_MS);
    });
  }

  function catalogRequestEvent(name, detail) {
    if (typeof window.dispatchEvent !== 'function' || typeof CustomEvent !== 'function') return;
    window.dispatchEvent(new CustomEvent(name, { detail: detail || {} }));
  }

  function catalogHttpError(status) {
    var error = new Error('catalog ' + status);
    error.code = 'catalog_http_' + status;
    error.status = status;
    error.retryable = status === 408 || status === 425 || status === 429 || status >= 500;
    return error;
  }

  function catalogTimeoutError(error) {
    var timeoutError = new Error('catalog_timeout');
    timeoutError.name = 'TimeoutError';
    timeoutError.code = 'catalog_timeout';
    timeoutError.retryable = true;
    timeoutError.cause = error;
    return timeoutError;
  }

  function isTransientCatalogError(error) {
    if (!error) return true;
    if (error.retryable === true) return true;
    if (error.retryable === false) return false;
    if (error.name === 'AbortError' || error.name === 'TimeoutError' || error.name === 'TypeError' || error.name === 'SyntaxError') {
      return true;
    }
    var status = Number(error.status || 0);
    return status === 408 || status === 425 || status === 429 || status >= 500;
  }

  async function fetchCatalogOnce(catalogUrl) {
    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timeoutId = controller
      ? setTimeout(function () { controller.abort(); }, CATALOG_REQUEST_TIMEOUT_MS)
      : null;
    try {
      var fetchOptions = { credentials: 'same-origin' };
      if (controller) fetchOptions.signal = controller.signal;
      var res = await fetch(catalogUrl, fetchOptions);
      if (!res.ok) throw catalogHttpError(res.status);
      var data = await res.json();
      if (!data || !Array.isArray(data.beads)) {
        var invalidError = new Error('catalog_invalid_response');
        invalidError.code = 'catalog_invalid_response';
        invalidError.retryable = true;
        throw invalidError;
      }
      return data;
    } catch (error) {
      if (error && (error.name === 'AbortError' || error.code === 20)) {
        throw catalogTimeoutError(error);
      }
      throw error;
    } finally {
      if (timeoutId) clearTimeout(timeoutId);
    }
  }

  async function requestCatalogData(options) {
    options = options || {};
    var catalogUrl = localizedUrl(BASE + '/api/catalog');
    if (
      catalogRequestInFlight
      && catalogRequestInFlight.url === catalogUrl
      && catalogRequestInFlight.promise
    ) {
      return await catalogRequestInFlight.promise;
    }

    var requestPromise = (async function () {
      var bootstrap = !options.force ? window.__iwCatalogBootstrap : null;
      var bootstrapMatches = Boolean(
        bootstrap
        && bootstrap.url === catalogUrl
        && bootstrap.dataPromise
        && typeof bootstrap.dataPromise.then === 'function'
      );
      var firstError = null;
      IW.catalogLoadMeta = {
        attemptCount: 1,
        bootstrapFailed: false,
        manualRetry: options.reason === 'manual',
        recovered: false,
      };

      try {
        if (bootstrapMatches) return await bootstrap.dataPromise;
        return await fetchCatalogOnce(catalogUrl);
      } catch (error) {
        firstError = error;
        IW.catalogLoadMeta.bootstrapFailed = bootstrapMatches;
        if (bootstrapMatches && window.__iwCatalogBootstrap === bootstrap) {
          window.__iwCatalogBootstrap = null;
        }
        if (options.retry === false || !isTransientCatalogError(error)) throw error;
      }

      IW.catalogLoadMeta.attemptCount = 2;
      catalogRequestEvent('iwobbl:catalog-retry', {
        attemptCount: 2,
        bootstrapFailed: IW.catalogLoadMeta.bootstrapFailed,
        manualRetry: IW.catalogLoadMeta.manualRetry,
        errorCode: String(firstError && (firstError.code || firstError.name || firstError.message) || 'catalog_failed'),
      });
      await waitForCatalogRetry();
      var recovered = await fetchCatalogOnce(catalogUrl);
      IW.catalogLoadMeta.recovered = true;
      return recovered;
    })();

    catalogRequestInFlight = { url: catalogUrl, promise: requestPromise };
    try {
      return await requestPromise;
    } finally {
      if (catalogRequestInFlight && catalogRequestInFlight.promise === requestPromise) {
        catalogRequestInFlight = null;
      }
    }
  }

  IW.loadCatalog = async function (options) {
    IW.catalogLoadError = null;
    try {
      var data = await requestCatalogData(options);
      IW.currency = data.currency;
      IW.country = data.country;
      IW.priceSource = data.priceSource;
      IW.trays = Array.isArray(data.trays) ? data.trays.map(function (t) {
        return {
          id: t.id, name: t.name, base: t.base, rim: t.rim,
          plateScale: t.plateScale, imageUrl: t.imageUrl, stageTone: t.stageTone,
        };
      }) : [];
      IW.sounds = Array.isArray(data.sounds) ? data.sounds.filter(function (u) { return typeof u === 'string' && u; }) : [];
      if (Array.isArray(data.hardwareKits) && data.hardwareKits.length) {
        var configuredByIdentity = new Map(data.hardwareKits.map(function (kit) {
          return [hardwareKitIdentity(kit), kit];
        }));
        IW.hardwareKits = IW.hardwareKits.map(function (fallback) {
          var configured = configuredByIdentity.get(hardwareKitIdentity(fallback))
            || data.hardwareKits.find(function (kit) {
              return kit.sku && fallback.sku && kit.sku === fallback.sku;
            });
          var merged = Object.assign({}, fallback, configured || {});
          merged.constructionType = hardwareConstructionType(merged);
          if (merged.constructionType === 'toggle_clasp') {
            var fallbackToggleRing = fallback.attachmentAnchors && fallback.attachmentAnchors.toggleRing;
            var configuredToggleRing = configured
              && configured.attachmentAnchors
              && configured.attachmentAnchors.toggleRing;
            merged.attachmentAnchors = Object.assign(
              {},
              fallback.attachmentAnchors || {},
              (configured && configured.attachmentAnchors) || {},
              {
                toggleRing: Object.assign(
                  {},
                  fallbackToggleRing || {},
                  configuredToggleRing || {},
                  { maxCount: 4 },
                ),
              },
            );
          }
          return merged;
        });
        data.hardwareKits.forEach(function (kit) {
          if (!IW.hardwareKits.some(function (known) {
            return hardwareKitIdentity(known) === hardwareKitIdentity(kit)
              || (known.sku && kit.sku && known.sku === kit.sku);
          })) {
            IW.hardwareKits.push(Object.assign({}, kit, {
              constructionType: hardwareConstructionType(kit),
            }));
          }
        });
      }
      return (data.beads || []).map(mapBead);
    } catch (e) {
      console.error('catalog load failed', e);
      IW.catalogLoadError = e;
      if (window.IW_FALLBACK_BEADS) return window.IW_FALLBACK_BEADS;
      return [];
    }
  };

  IW.loadClone = async function (id) {
    var res = await fetch(localizedUrl(BASE + '/api/design/' + encodeURIComponent(id)), { credentials: 'same-origin', headers: headers() });
    if (!res.ok) return null;
    return await res.json();
  };

  IW.loadTemplate = async function (id) {
    var res = await fetch(localizedUrl(BASE + '/api/design-templates/' + encodeURIComponent(id)), {
      credentials: 'same-origin',
      headers: headers(),
      cache: 'no-store',
    });
    var data = await res.json().catch(function () { return {}; });
    if (!res.ok) {
      var error = new Error(data.error || ('design-template ' + res.status));
      error.code = data.error || 'template_restore_failed';
      error.data = data;
      throw error;
    }
    return data;
  };

  IW.loadRandomInspiration = async function (options) {
    options = options || {};
    var query = [
      options.excludeId ? 'exclude=' + encodeURIComponent(options.excludeId) : '',
      Array.isArray(options.skipIds) && options.skipIds.length ? 'skip=' + encodeURIComponent(options.skipIds.join(',')) : '',
      options.productType ? 'productType=' + encodeURIComponent(options.productType) : '',
      options.mode ? 'mode=' + encodeURIComponent(options.mode) : '',
      options.constructionType ? 'constructionType=' + encodeURIComponent(options.constructionType) : '',
    ].filter(Boolean).join('&');
    query = query ? '?' + query : '';
    var res = await fetch(localizedUrl(BASE + '/api/inspirations/random' + query), {
      credentials: 'same-origin', headers: headers(), cache: 'no-store',
    });
    var data = await res.json().catch(function () { return {}; });
    if (!res.ok) {
      var error = new Error(data.error || 'inspiration_failed');
      error.code = data.error || 'inspiration_failed';
      throw error;
    }
    return data;
  };

  IW.save = async function (payload) {
    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timeoutId = controller ? setTimeout(function () { controller.abort(); }, 15000) : null;
    try {
      var options = {
        method: 'POST', credentials: 'same-origin',
        headers: headers({ 'Content-Type': 'application/json' }), body: JSON.stringify(payload),
      };
      if (controller) options.signal = controller.signal;
      var res = await fetch(BASE + '/api/design', options);
      var data = await res.json().catch(function () { return {}; });
      if (!res.ok) {
        var error = new Error(data.message || data.error || ('save ' + res.status));
        error.code = data.error || 'save_failed';
        error.data = data;
        throw error;
      }
      return data;
    } finally {
      if (timeoutId) clearTimeout(timeoutId);
    }
  };

  IW.checkout = async function (payload, mode) {
    /* Review Design (add): save design then jump to detail confirm page; buy: detail page Buy Now direct purchase (original flow) */
    if (mode === 'add') {
      var saved = await IW.save(payload);
      try {
        if (payload.previewDataUrl) {
          sessionStorage.setItem('iw_pending_preview:' + saved.designId, payload.previewDataUrl);
        }
        sessionStorage.setItem('iw_analytics_review_receipt', JSON.stringify({
          designId: saved.designId,
          savedAt: Date.now(),
        }));
      } catch (e) {}
      try {
        if (window.IWAnalytics && typeof window.IWAnalytics.track === 'function') {
          if (typeof window.IWAnalytics.setDesignId === 'function') {
            window.IWAnalytics.setDesignId(saved.designId);
          }
          window.IWAnalytics.track('designer_review_success', {
            result: 'success',
            design_id_present: Boolean(saved.designId),
            product_type: payload.productType || 'bracelet',
            design_mode: payload.productType === 'pet'
              ? 'pet'
              : (payload.strandCount > 1 ? 'stacked' : (payload.wrapTurns === 2 ? 'double' : 'single')),
            bead_count: Number(payload.beadCount) || (Array.isArray(payload.items) ? payload.items.length : 0),
            unique_material_count: Array.isArray(payload.items)
              ? new Set(payload.items.map(function (item) { return item.sku; })).size
              : 0,
            strand_count: Number(payload.strandCount) || 1,
            total_cents: Number(payload.totalCents) || 0,
          });
        }
      } catch (e) {}
      var btn = document.getElementById('cartBtn');
      var du = (btn && btn.dataset.detailUrl) || '/pages/design-detail';
      location.href = du + '?d=' + encodeURIComponent(saved.designId) + '&from=designer';
      return saved;
    }
    var welcomeDiscount = window.IWWelcomeDiscount;
    var welcomeDiscountCode = welcomeDiscount && typeof welcomeDiscount.getCodeForCheckout === 'function'
      ? welcomeDiscount.getCodeForCheckout()
      : null;
    var checkoutEmail = null;
    if (
      welcomeDiscountCode
      && welcomeDiscount
      && typeof welcomeDiscount.requestCheckoutEmail === 'function'
    ) {
      checkoutEmail = await welcomeDiscount.requestCheckoutEmail();
      if (!checkoutEmail) {
        var cancelled = new Error('checkout_cancelled');
        cancelled.code = 'checkout_cancelled';
        throw cancelled;
      }
    }
    var res = await fetch(BASE + '/api/cart/draft', {
      method: 'POST', credentials: 'same-origin',
      headers: headers({ 'Content-Type': 'application/json' }),
      body: JSON.stringify({
        items: payload.items, wristSizeCm: payload.wristSizeCm, designId: payload.designId,
        mode: mode || 'buy', gift: payload.gift, productType: payload.productType,
        wrapTurns: payload.wrapTurns, neckSizeCm: payload.neckSizeCm,
        necklaceLengthCm: payload.necklaceLengthCm, targetLengthCm: payload.targetLengthCm,
        targetWristCm: payload.targetWristCm, strandCount: payload.strandCount,
        constructionType: payload.constructionType, hardwareFinish: payload.hardwareFinish,
        hardwareKitSku: payload.hardwareKitSku, hardwareQuantity: payload.hardwareQuantity,
        components: payload.components,
        discountCode: welcomeDiscountCode,
        checkoutEmail: checkoutEmail,
        countryCode: window.IWCurrency && window.IWCurrency.context.countryCode,
        currencyCode: IW.currency || (window.IWCurrency && window.IWCurrency.context.currencyCode),
      }),
    });
    var data = await res.json().catch(function () { return {}; });
    if (!res.ok) { var err = new Error(data.error || 'checkout_failed'); err.data = data; throw err; }
    if (
      welcomeDiscountCode
      && welcomeDiscount
      && typeof welcomeDiscount.markDraftCheckoutPrepared === 'function'
      && typeof data.discountApplied === 'boolean'
    ) {
      welcomeDiscount.markDraftCheckoutPrepared({
        code: welcomeDiscountCode,
        applied: data.discountApplied === true,
        eligibility: data.discountEligibility,
      });
    }
    if (data.invoiceUrl) location.href = data.invoiceUrl;
    return data;
  };
})();
